import {
  DeleteTwoTone,
  EditTwoTone,
  LoadingOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import React from "react";
import Search from "antd/es/input/Search";
import { ColumnsType } from "antd/es/table";
import { adminContext } from "../../Common/PageRoute";
import PracticeBankAccountService from "../../Services/PracticeBankAccountService";
import { IPagingPagingItems } from "../../Common/CommonComponent";
import { AddPracticeBank } from "./AddPracticeBank";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { useUser } from "../../Context/UserContext";
interface ListDataType {
  key: React.Key;
  sno: number;
  id: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  isActive: number;
  primary: number;
}

interface ListData {
  items: ListDataType[];
  totalItems: number;
}
export const PracticeBankAccount = ({
  practiceId,
  onPrimaryChange,
}: {
  practiceId: number;
  onPrimaryChange?: () => void;
}) => {
  const [loading, setLoading] = React.useState(false);
  const { openNotification } = React.useContext(adminContext);
  const { isSubAdmin } = useUser();
  const isViewOnly = isSubAdmin();
  const [bankList, setBankList] = React.useState<ListData>({
    items: [],
    totalItems: 0,
  });
  const [pagingItems, setPagingItems] = React.useState<IPagingPagingItems>({
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
  });
  const [listParams, setListParams] = React.useState<{
    search: string;
    sortDir: string;
    sortCol: string;
    status: number;
  }>({
    search: "",
    sortDir: "asc",
    sortCol: "Name",
    status: 0,
  });
  const [dialog, setDialog] = React.useState({
    show: false,
    type: "",
    recordId: "",
    status: false,
  });
  const [shouldRefresh, setShouldRefresh] = React.useState(true);
  const [showDialog, setShowDialog] = React.useState<{
    type: string;
    recordId?: string;
  }>({ type: "", recordId: "" });

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "4%",
      render: (_: any, record: any, index: any) => (
        <p>
          {pagingItems.currentPage > 1
            ? pagingItems.pageSize * (pagingItems.currentPage - 1) + index + 1
            : index + 1}
        </p>
      ),
    },
    {
      title: "Account name",
      dataIndex: "accountName",
      key: "accountName",
      width: "15%",
    },
    {
      title: "Bank name",
      dataIndex: "bankName",
      key: "bankName",
      width: "20%",
    },
    {
      title: "Account number",
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: "13%",
    },
    {
      title: "Primary",
      dataIndex: "primary",
      key: "primary",
      width: "10%",
      render: (text: any, record: any) => {
        return (
          <Checkbox
            checked={record?.primary ? true : false}
            disabled={isViewOnly}
            onClick={() => {
              setDialog({
                show: true,
                recordId: record?.id,
                status: record?.primary,
                type: "primary",
              });
            }}
          />
        );
      },
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "Id",
      width: "9%",
      render: (text: any, record: any) => (
        <>
          <Space wrap>
            <div style={{ display: "flex", alignItems: "center" }}>
              {
                !isViewOnly &&
                <div style={{ textAlign: "center" }} >
                  <Button type="text" size="small">
                    <EditTwoTone
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setShowDialog({ type: "addBank", recordId: record?.id });
                      }}
                      title="Edit"
                    />
                  </Button>
                </div>
              }
              <div style={{ textAlign: "center" }}>
                {record?.isActive === 0 ? (
                  <>
                    <Button type="text" disabled={isViewOnly} size="small">
                      <DeleteTwoTone
                        twoToneColor="#ff4d4f"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setDialog({
                            show: true,
                            recordId: record?.id,
                            status: record?.isActive === 0 ? true : false,
                            type: "active",
                          });
                        }}
                        title="Delete"
                      />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button type="text" disabled={isViewOnly} size="small">
                      <ReloadOutlined
                        rotate={270}
                        style={{ color: "#0093FF", cursor: "pointer" }}
                        title="Reset"
                        onClick={() => {
                          setDialog({
                            show: true,
                            recordId: record?.id,
                            status: record?.isActive === 0 ? true : false,
                            type: "active",
                          });
                        }}
                      />
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Space>
        </>
      ),
    },
  ];

  const getItems = async (start: any, length: any) => {
    setLoading(true);
    let res = await PracticeBankAccountService.getList(
      start,
      length,
      listParams.search,
      listParams.status,
      practiceId ?? 0,
    );
    if (res) {
      // setShouldRefresh(false);
      setLoading(false);
      var data: any[] = res?.items.map((item: any) => {
        var itemWithKey = {
          key: item?.id,
          id: item?.id,
          accountName: item?.accountName,
          accountNumber: item?.accountNumber,
          bankName: item?.bankName,
          isActive: item?.isActive,
          primary: item?.primary,
        };
        return itemWithKey;
      });
      setBankList({
        totalItems: res?.totalRecords,
        items: data,
      });
    } else {
      setLoading(false);
      // setShouldRefresh(false);
      openNotification("error", res?.message);
    }
  };

  React.useEffect(() => {
    getItems(
      (pagingItems.currentPage - 1) * pagingItems.pageSize,
      pagingItems.pageSize,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listParams.search, listParams.status, shouldRefresh]);

  const setListParamsAndRefresh = (key: any, value: any) => {
    setPagingItems({ ...pagingItems, currentPage: 1, pageSize: 15 });
    setListParams((p: any) => ({ ...p, [key]: value }));
  };

  return (
    <>
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <Row
          style={{
            backgroundColor: "white",
          }}
        >
          <Col span={24}>
            <Row gutter={[8, 8]} className="pb-3" align="middle">
              {/* ================= ADD ================= */}
              <Col xs={{ span: 12, order: 1 }} sm={8} md={6} lg={2} xxl={2}>
                {!isViewOnly && (
                  <Button
                    type="primary"
                    className="add-btn"
                    block
                    onClick={() =>
                      setShowDialog({ type: "addBank", recordId: "" })
                    }
                  >
                    <PlusOutlined />
                    Bank
                  </Button>
                )}
              </Col>
              {/* ================= SEARCH ================= */}
              <Col
                xs={{ span: 24, order: 3 }}
                sm={{ span: 8, order: 2 }}
                md={{ span: 6, offset: 6 }}
                lg={{ span: 4, offset: 15 }}
                xxl={{ span: 3, offset: 17 }}
              >
                <Search
                  placeholder="Search"
                  onSearch={(val: string) =>
                    setListParamsAndRefresh("search", val)
                  }
                  onChange={(e) => setListParamsAndRefresh("search", "")}
                  style={{ width: "100%" }}
                />
              </Col>
              {/* ================= STATUS ================= */}
              <Col
                xs={{ span: 12, order: 2 }}
                sm={{ span: 8, order: 3 }}
                md={6}
                lg={3}
                xxl={2}
              >
                <Select
                  style={{ width: "100%" }}
                  options={[
                    { value: 0, label: "All" },
                    { value: 1, label: "Active" },
                    { value: 2, label: "Deleted" },
                  ]}
                  defaultValue={0} // Set Active as the default
                  onChange={(value) => setListParamsAndRefresh("status", value)}
                />
              </Col>
            </Row>
          </Col>

          <Col
            span={24}
          // style={{ minHeight: window.outerHeight - 200 }}
          >
            <Table
              dataSource={bankList?.items}
              columns={columns}
              size="small"
              className="border-top-table"
              scroll={
                (bankList?.items?.length || 0) > 15
                  ? { y: "calc(100vh - 340px)", x: "max-content" }
                  : undefined
              }
              pagination={{
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,

                current: pagingItems.currentPage,

                pageSize: pagingItems.pageSize,
                showSizeChanger: true,
                total: bankList?.totalItems,
                pageSizeOptions: ["15", "25", "50", "100"],
              }}
              onChange={(paging, filter, sort: any) => {
                sort.order !== undefined &&
                  setListParams({
                    ...listParams,
                    sortDir: sort.order,
                    sortCol: sort.columnKey,
                  });
                if (
                  paging?.current !== undefined &&
                  paging?.pageSize !== undefined
                ) {
                  //setLoading(true);
                  setPagingItems((p) => {
                    p.currentPage =
                      paging.current !== undefined ? paging.current : 1;
                    p.pageSize =
                      paging.pageSize !== undefined ? paging.pageSize : 15;
                    return p;
                  });
                  getItems(
                    (paging.current - 1) * paging.pageSize,
                    paging.pageSize,
                  );
                }
              }}
            />
          </Col>
        </Row>
      </Spin>
      {showDialog.type === "addBank" && (
        <AddPracticeBank
          practiceId={practiceId ?? 0}
          recordId={showDialog?.recordId}
          onDismiss={(data) => {
            if (data?.isUpdated) {
              setShouldRefresh(x => !x);
              if (data?.isPrimary) {
                onPrimaryChange && onPrimaryChange();
              }
            }

            setShowDialog({ type: "", recordId: "" });
          }}
        />
      )}
      {dialog.show && (
        <ConfirmationModal
          open={true}
          onNo={() => {
            setDialog({ type: "", recordId: "", status: false, show: false });
          }}
          onYes={async () => {
            try {
              dialog.type === "primary"
                ? await PracticeBankAccountService.markPrimary(
                  dialog.recordId,
                  practiceId ?? 0,
                ).then((result) => {
                  if (result.status) {
                    setShouldRefresh(x => !x);
                    onPrimaryChange && onPrimaryChange();
                  } else {
                    openNotification("error", result?.message);
                  }
                })
                : await PracticeBankAccountService.remove(
                  dialog.recordId,
                  practiceId ?? 0,
                ).then((result: any) => {
                  if (result.status) {
                    setShouldRefresh(x => !x);
                  } else {
                    openNotification("error", result?.message);
                  }
                });
              setDialog({ type: "", recordId: "", status: false, show: false });
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setDialog({ type: "", recordId: "", status: false, show: false });
            } finally {
              setDialog({ type: "", recordId: "", status: false, show: false });
            }
          }}
          text={`${dialog.type === "primary"
            ? `Are you sure to ${dialog.status ? "remove as primary" : "mark as primary"}`
            : `Are you sure to ${dialog.status ? "mark as delete" : "mark as active"}`
            } ?`}
        />
      )}

      {/* <Divider orientation="left">Small Size</Divider> */}
    </>
  );
};
